import { TableCell, TableRow } from "../../../ui/common/table";
import { VERSION_HISTORY_COLUMNS } from "../constants/versionHistory.constants";
import { VersionDetailsDraft, VersionHistoryGroup } from "../types/versionHistory.types";
import { VersionDetailsSection } from "./VersionDetailsSection";

interface VersionDetailsRowProps {
  version: VersionHistoryGroup;
  yearOptions: number[];
  currencyCode: string;
  versionLabel: string;
  isEditing: boolean;
  isSaving: boolean;
  onCommit: (draft: VersionDetailsDraft) => Promise<string | null>;
  onCancel: () => void;
  onRequestDelete: () => void;
}

/**
 * Table-structure wrapper only: the details block spans every column, exactly like the version
 * bar above it, so it shares the one table the calculation rows also live in.
 */
export const VersionDetailsRow = ({ version, ...sectionProps }: VersionDetailsRowProps) => (
  <TableRow className="tw-bg-primary/5 hover:tw-bg-primary/5">
    <TableCell colSpan={VERSION_HISTORY_COLUMNS.length} className="tw-py-3 tw-pl-8">
      <VersionDetailsSection version={version} {...sectionProps} />
    </TableCell>
  </TableRow>
);
